import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  discountPrice: "",
};

export const discountedPrice = createSlice({
  name: "price",
  initialState,
  reducers: {
    setDiscountedPrices: (state, action) => {
      state.discountPrice = action.payload;
    },
  },
});

export const { setDiscountedPrices } = discountedPrice.actions;
export default discountedPrice.reducer;
